

export const getDisks = 'disk/getDisks';
export const getDisksAllNum = 'disk/getDisks';
export const createLocalSnap = 'disk/createLocalSnap';
export const getLocalSnapLists = 'disk/getLocalSnapLists';
export const diskMonitor = 'disk/diskMonitor';
export const monitorScreen = 'disk/monitorScreen';
export const metricsData = 'disk/metricsData';
export const deleteDisks = 'disk/deleteDisks';
export const getDisksSilence = 'disk/getDisksSilence';
export const describeEbsVolumes = 'disk/describeEbsVolumes';
export const validLocalImageSupport = 'disk/validLocalImageSupport';
